import Vue from 'vue';

/* Vue does not allow inline styling blocks.
https://dev.to/plop/how-to-inline-the-style-tag-in-vue-2j26 */
export default Vue.component('v-style', {
    render: function (createElement) {
        return createElement('style', this.$slots.default)
    }
});